/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EventClassification
 */
export interface EventClassification {
    /**
     * 
     * @type {string}
     * @memberof EventClassification
     */
    segment?: string;
    /**
     * 
     * @type {string}
     * @memberof EventClassification
     */
    genre?: string;
    /**
     * 
     * @type {string}
     * @memberof EventClassification
     */
    subgenre?: string;
}

/**
 * Check if a given object implements the EventClassification interface.
 */
export function instanceOfEventClassification(value: object): value is EventClassification {
    return true;
}

export function EventClassificationFromJSON(json: any): EventClassification {
    return EventClassificationFromJSONTyped(json, false);
}

export function EventClassificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventClassification {
    if (json == null) {
        return json;
    }
    return {
        
        'segment': json['segment'] == null ? undefined : json['segment'],
        'genre': json['genre'] == null ? undefined : json['genre'],
        'subgenre': json['subgenre'] == null ? undefined : json['subgenre'],
    };
}

export function EventClassificationToJSON(json: any): EventClassification {
    return EventClassificationToJSONTyped(json, false);
}

export function EventClassificationToJSONTyped(value?: EventClassification | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'segment': value['segment'],
        'genre': value['genre'],
        'subgenre': value['subgenre'],
    };
}

